import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const ProvinciaContext = React.createContext(null);

const { Provider } = ProvinciaContext;

export const ProvinciaProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        provincia: null,
        regioni: null,
        regioniOptions: [],
    });

    const [isLoadingProvincia, setIsLoadingProvincia] = useState(false);
    const getProvinciaAsync = async (provinciaId) => {
        try {
            setIsLoadingProvincia(true);
            const r = await fetchAuthorized(ApiRoutes.Provincia.GetProvincia({ provinciaId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            setState({ provincia: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingProvincia(false);
        }
    }

    const [isUpdatingProvincia, setIsUpdatingProvincia] = useState(false);
    const updateProvinciaAsync = async (provinciaId, provincia) => {
        try {
            setIsUpdatingProvincia(true);
            const r = await fetchAuthorized(ApiRoutes.Provincia.UpdateProvincia({ provinciaId }), {
                method: HttpMethods.POST,
                body: JSON.stringify(provincia),
            });
            const result = await r.json();
            setState({
                provincia: {
                    ...result,
                    inizioValidita: new Date(result.inizioValidita),
                    fineValidita: result.fineValidita ? new Date(result.fineValidita) : null
                }
            });
            showSuccessMessage("Provincia aggiornata");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingProvincia(false);
        }
    }

    const [isAddingProvincia, setIsAddingProvincia] = useState(false);
    const addProvinciaAsync = async (provincia) => {
        try {
            setIsAddingProvincia(true);
            const r = await fetchAuthorized(ApiRoutes.Provincia.AddProvincia(), {
                method: HttpMethods.PUT,
                body: JSON.stringify(provincia),
            });
            const result = await r.json();
            setState({
                provincia: {
                    ...result,
                    inizioValidita: new Date(result.inizioValidita),
                    fineValidita: result.fineValidita ? new Date(result.fineValidita) : null
                }
            });
            showSuccessMessage("Provincia creata");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingProvincia(false);
        }
    }

    const [isLoadingRegioni, setIsLoadingRegioni] = useState(false);
    const getRegioniAsync = async (term = null, pageIndex = 0, pageSize = 100) => {
        try {
            setIsLoadingRegioni(true);
            const r = await fetchAuthorized(ApiRoutes.Regione.GetRegioni({ term, pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({
                regioni: list, regioniOptions: list.result.map(e => {
                    return { regioneId: e.id, label: `${e.descrizione}` }
                }).sort((a, b) => a.label.localeCompare(b.label))
            });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingRegioni(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingProvincia,
            getProvinciaAsync,

            isUpdatingProvincia,
            updateProvinciaAsync,

            isAddingProvincia,
            addProvinciaAsync,

            isLoadingRegioni,
            getRegioniAsync,
        }}>
            {props.children}
        </Provider>
    );
}